import config from '../config/urlConfig';
import { loadImage } from '../util/image';

export default class {
  public id;
  public ten;
  public url;
  public loaiDuAnId;
  public detail;
  public loaiDuAn;
  public loaiDuAnUrl;
  public thuTuHienThi;
  public mieuTa;
  public hinhAnh;
  public danhSachTinLienQuan;
  public tenLoaiDuAN;
  public tagSeo;
  public jsonb_content;
  public url_loai_du_an;
  constructor(options) {
    this.id = options.du_an_id || null;
    this.ten = options.ten || '';
    this.url = options.url || '';
    this.loaiDuAnId = options.loai_du_an_id || null;
    this.detail = options.jsonb_detail || null;
    this.loaiDuAn = options.loai_du_an || '';
    this.loaiDuAnUrl = options.loai_du_an_url || '';
    this.thuTuHienThi = options.thu_tu_hien_thi || null;
    this.mieuTa = options.jsonb_content ? options.jsonb_content.mieu_ta : '';
    this.hinhAnh = options.jsonb_content
      ? loadImage(options.jsonb_content.hinh_anh)
      : '';
    this.tenLoaiDuAN = options.ten_loai_du_an;
    if (options.jsonb_content) {
      this.tagSeo = options.jsonb_content.tag_seo || [];
    }
    this.jsonb_content = options.jsonb_content || null;

    this.url_loai_du_an = options.url_loai_du_an || '';
  }
}
